import React from "react";
import TableClientTeam from "../../components/Tables/client-team";

const ClientTeam = () => {
  return (
    <TableClientTeam isPage={true} />
  );
};
export default ClientTeam;
